import { render, staticRenderFns } from "./FundHoldLegend.vue?vue&type=template&id=1cbd1ba6&scoped=true&"
import script from "./FundHoldLegend.vue?vue&type=script&lang=js&"
export * from "./FundHoldLegend.vue?vue&type=script&lang=js&"
import style0 from "./FundHoldLegend.vue?vue&type=style&index=0&id=1cbd1ba6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbd1ba6",
  null
  
)

export default component.exports